import { render, staticRenderFns } from "./dialog-presence.vue?vue&type=template&id=27f831f0&"
import script from "./dialog-presence.vue?vue&type=script&lang=js&"
export * from "./dialog-presence.vue?vue&type=script&lang=js&"
import style0 from "./dialog-presence.vue?vue&type=style&index=0&id=27f831f0&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports